export const shopifyRoleOptions = [
  // Setup & Migration
  { value: 'Shopify Setup Specialist', label: 'Shopify Setup Specialist' },
  { value: 'Theme Installer', label: 'Theme Installer' },
  { value: 'Product Import Specialist', label: 'Product Import Specialist' },
  { value: 'Migration Specialist', label: 'Migration Specialist' },

  // Development Roles
  { value: 'Front-End Developer', label: 'Front-End Developer' },
  { value: 'Theme Developer', label: 'Theme Developer' },
  { value: 'UX/UI Integrator', label: 'UX/UI Integrator' },
  { value: 'Shopify App Developer', label: 'Shopify App Developer' },
  { value: 'API Integration Engineer', label: 'API Integration Engineer' },
  { value: 'Back-End Developer', label: 'Back-End Developer' },
  { value: 'Shopify Plus Engineer', label: 'Shopify Plus Engineer' },
  { value: 'Technical Architect', label: 'Technical Architect' },
  { value: 'QA / Automation Tester', label: 'QA / Automation Tester' },

  // Design Roles
  { value: 'Brand Designer', label: 'Brand Designer' },
  { value: 'Art Director', label: 'Art Director' },
  { value: 'Logo Designer', label: 'Logo Designer' },
  { value: 'UX Designer', label: 'UX Designer' },
  { value: 'UI Designer', label: 'UI Designer' },
  { value: 'Conversion-Focused Designer', label: 'Conversion-Focused Designer' },
  { value: 'Creative Director', label: 'Creative Director' },
  { value: 'Visual Strategist', label: 'Visual Strategist' },

  // Creative & Content
  { value: 'Product Photographer', label: 'Product Photographer' },
  { value: 'Image Retoucher', label: 'Image Retoucher' },
  { value: 'Creative Producer', label: 'Creative Producer' },
  { value: 'SEO Specialist', label: 'SEO Specialist' },
  { value: 'Copywriter', label: 'Copywriter' },
  { value: 'Content Strategist', label: 'Content Strategist' },

  // Paid Marketing
  { value: 'Paid Media Manager', label: 'Paid Media Manager' },
  { value: 'Google Ads Specialist', label: 'Google Ads Specialist' },
  { value: 'Meta Ads Expert', label: 'Meta Ads Expert' },
  { value: 'TikTok Ads Manager', label: 'TikTok Ads Manager' },

  // Email & Retention Marketing
  { value: 'Klaviyo Expert', label: 'Klaviyo Expert' },
  { value: 'Email Marketing Specialist', label: 'Email Marketing Specialist' },
  { value: 'Retention Strategist', label: 'Retention Strategist' },

  // Conversion & Analytics
  { value: 'CRO Specialist', label: 'CRO Specialist' },
  { value: 'A/B Testing Analyst', label: 'A/B Testing Analyst' },
  { value: 'Funnel Strategist', label: 'Funnel Strategist' },
  { value: 'Data Analyst', label: 'Data Analyst' },
  { value: 'GA4 Specialist', label: 'GA4 Specialist' },
  { value: 'Attribution Expert', label: 'Attribution Expert' },

  // Strategy & Consulting
  { value: 'Shopify Consultant', label: 'Shopify Consultant' },
  { value: 'Ecommerce Strategist', label: 'Ecommerce Strategist' },
  { value: 'Growth Consultant', label: 'Growth Consultant' },
  { value: 'Shopify Plus Consultant', label: 'Shopify Plus Consultant' },

  // Operations & Management
  { value: 'Ecommerce Operations Manager', label: 'Ecommerce Operations Manager' },
  { value: 'Fulfillment Consultant', label: 'Fulfillment Consultant' },
  { value: 'Product Listing Specialist', label: 'Product Listing Specialist' },
  { value: 'Catalog Manager', label: 'Catalog Manager' },
  { value: 'Inventory Manager', label: 'Inventory Manager' },
  { value: 'Order Fulfillment Coordinator', label: 'Order Fulfillment Coordinator' },
  { value: 'Supply Chain Consultant', label: 'Supply Chain Consultant' },

  // Automation & Integration
  { value: 'Workflow Automation Specialist', label: 'Workflow Automation Specialist' },
  { value: 'ERP Integration Expert', label: 'ERP Integration Expert' },
  { value: 'Shopify App Integration Expert', label: 'Shopify App Integration Expert' },
  { value: 'API Specialist', label: 'API Specialist' },

  // Customer Experience
  { value: 'CX Manager', label: 'CX Manager' },
  { value: 'Helpdesk Specialist', label: 'Helpdesk Specialist' },
  { value: 'Chat Support Agent', label: 'Chat Support Agent' },
  { value: 'Retention Specialist', label: 'Retention Specialist' },
  { value: 'Loyalty Program Strategist', label: 'Loyalty Program Strategist' },
  { value: 'Review Management Specialist', label: 'Review Management Specialist' },

  // Advanced Development
  { value: 'Headless Developer', label: 'Headless Developer' },
  { value: 'Frontend Engineer', label: 'Frontend Engineer' },
  { value: 'Workflow Automation Developer', label: 'Workflow Automation Developer' },
  { value: 'AI Chatbot Builder', label: 'AI Chatbot Builder' },
  { value: 'Product Recommendation Engineer', label: 'Product Recommendation Engineer' },

  // International & Localization
  { value: 'Translation Specialist', label: 'Translation Specialist' },
  { value: 'Multilingual Store Expert', label: 'Multilingual Store Expert' },
  { value: 'Payments Specialist', label: 'Payments Specialist' },
  { value: 'Shopify Markets Expert', label: 'Shopify Markets Expert' },
  { value: 'Logistics Strategist', label: 'Logistics Strategist' },
  { value: 'Cross-Border Consultant', label: 'Cross-Border Consultant' },

  // Agency & Management
  { value: 'Agency Owner', label: 'Agency Owner' },
  { value: 'Account Manager', label: 'Account Manager' },
  { value: 'Project Manager', label: 'Project Manager' },
  { value: 'Sales Representative', label: 'Sales Representative' },
  { value: 'Technical Lead', label: 'Technical Lead' },
  { value: 'Client Success Manager', label: 'Client Success Manager' },
  { value: 'QA Specialist', label: 'QA Specialist' }
]

export const agencyRepresentativeRoleOptions = [
  { value: 'Agency Owner', label: 'Agency Owner' },
  { value: 'Managing Director', label: 'Managing Director' },
  { value: 'Chief Executive Officer', label: 'Chief Executive Officer' },
  { value: 'Operations Director', label: 'Operations Director' },
  { value: 'Account Director', label: 'Account Director' },
  { value: 'Account Manager', label: 'Account Manager' },
  { value: 'Senior Account Manager', label: 'Senior Account Manager' },
  { value: 'Project Manager', label: 'Project Manager' },
  { value: 'Senior Project Manager', label: 'Senior Project Manager' },
  { value: 'Client Success Manager', label: 'Client Success Manager' },
  { value: 'Business Development Manager', label: 'Business Development Manager' },
  { value: 'Sales Director', label: 'Sales Director' },
  { value: 'Technical Lead', label: 'Technical Lead' },
  { value: 'Technical Director', label: 'Technical Director' },
  { value: 'Creative Director', label: 'Creative Director' },
  { value: 'Strategy Director', label: 'Strategy Director' },
  { value: 'Partner', label: 'Partner' },
  { value: 'Co-Founder', label: 'Co-Founder' },
]
